<template>
    <div class="fill-height of-y d-flex flex-column">


        <div class="d-flex align-center justify-center fill-height flex-column" v-if="loadingReport">
            <loader :size="60"></loader>
        </div>

        <template v-else>
            <div class="flex-grow-0 pa-2 d-flex justify-space-between">
                <v-btn
                        :disabled="false"
                        @click="exportReportData"
                        color="primary"
                        small
                        :loading="exportingData"
                >
                    Export
                </v-btn>
                <div class="flex-grow-1">

                </div>
                <div style="width: 30%">
                    <v-text-field
                            v-model="search"
                            prepend-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                            class="pa-0 ma-0"
                    ></v-text-field>
                </div>
<!--                <div>-->
<!--                    <v-btn-->
<!--                            icon-->
<!--                            color="primary"-->
<!--                            class="pa-0 mr-2"-->
<!--                            @click="$emit('update:selected-date', subDays(selectedDate, 1))"-->
<!--                    >-->
<!--                        <v-icon>mdi-chevron-left</v-icon>-->
<!--                    </v-btn>-->
<!--                    <v-btn-->
<!--                            icon-->
<!--                            color="primary"-->
<!--                            class="pa-0 mr-2"-->
<!--                            @click="$emit('update:selected-date', addDays(selectedDate, 1))"-->
<!--                    >-->
<!--                        <v-icon>mdi-chevron-right</v-icon>-->
<!--                    </v-btn>-->
<!--                </div>-->
            </div>
            <div class="flex-grow-1 of-y">
                <v-data-table
                        :search="search"
                        dense
                        height="calc(100% - 80px)"
                        class="fill-height of-y"
                        :headers="headers"
                        :items="data"
                ></v-data-table>
            </div>
        </template>


    </div>
</template>

<script>

import {addDays, format, subDays} from "date-fns";
import {mapGetters} from "vuex";
import Loader from "../General/Loader/Loader";

export default {
    components: {Loader},
    props: {
        selectedFarm: Number,
        selectedDate: Date
    },
    data() {
        return {
            search: null,
            headers: [
                {text: "Farm", value: "farm"},
                {text: "Emp Code", value: "empCode"},
                {text: "Salom Scan ID", value: "salomScanID"},
                {text: "Full Name", value: "fullName"},
                {text: "Team", value: "team"},
                {text: "ID / Passport No", value: "idNo"},
                {text: "Asylum Expiry", value: "asylumExpiry"},
                {text: "Gender", value: "gender"},
                {text: "Job Desc", value: "jobDesc"},
                {text: "Export ID", value: "exportID"},
                {text: "Barcodes", value: "barcodes"},
            ],
            data: [],
            addDays: addDays,
            subDays: subDays,
            exportingData: false,
            loadingReport: true,
        }
    },
    watch: {
        selectedFarm: {
            immediate: true,
            handler() {
                this.getReportData()
            }
        },
        selectedDate(val) {
            if (val) {
                this.getReportData()
            }
        }
    },
    methods: {
        async getReportData() {
            try {
                this.loadingReport = true;
                this.data = await this.$newReq('POST', `reports/employee`, {
                    farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs,
                    allEmps: this.farms.length === this.availableFarmIDs.length
                })
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingReport = false
            }
        },
        exportReportData() {
            this.exportingData = true;
            this.$newReqDownloadFile(
                    'POST',
                    `reports/employee/export`,
                    {farms: this.selectedFarm ? [this.selectedFarm] : this.availableFarmIDs, allEmps: this.farms.length === this.availableFarmIDs.length},
                    `Employee Export ${format(this.selectedDate, 'MM-dd')}.xlsx`
            )
                    .then(data => {
                        console.log(data)
                    })
                    .catch(e => {
                        console.log(e)
                        this.$snack.netWorkError();
                    })
                    .finally(() => {
                        this.exportingData = false
                    })
        }
    },
    computed: {
        ...mapGetters(['farmsRef', 'availableFarms', 'availableFarmIDs', 'farms']),
        farm() {
            return this.selectedFarm ? this.farmsRef[this.selectedFarm] : null
        },
        // rows() {
        //     return this.data.map(row => {
        //         return {
        //             farmID: row.farm.id,
        //             farm: row.farm.description,
        //             employee: row.emp.fullName,
        //             empCode: row.emp.empCode,
        //             clockIn: row.clockInStr,
        //             lastAction: row.lastActionStr,
        //             binUnits: row.binUnits,
        //             piecework: row.pieceWorkStr,
        //             pWUnits: row.pieceWorkUnits,
        //             hours: row.hours,
        //         }
        //     }).filter((row) => this.selectedFarm ? row.farmID === this.selectedFarm : true)
        // }
    },
}
</script>

<style scoped>

</style>